import { render, staticRenderFns } from "./BButtonComments.vue?vue&type=template&id=4acf2fac&"
import script from "./BButtonComments.vue?vue&type=script&lang=js&"
export * from "./BButtonComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports